// Action types for the startup slice. Kept minimal for the marketing site;
// extend as authenticated consulting features are added.
export const INITIATE_STARTUP_CREATION = "INITIATE_STARTUP_CREATION";
export const STARTUP_CREATION_SUCCESS = "STARTUP_CREATION_SUCCESS";
export const STARTUP_CREATION_FAILURE = "STARTUP_CREATION_FAILURE";
